import { Button, Form, Modal, Spin } from 'antd'
import React from 'react'
import { useLogin } from '@api/hernest/Login/useLogin'
import { routesPath } from '@api/hernest/utils'
// import { policyData } from '../../pages/Detail/components/Policy'
import PasswordValidatorNode from '@ui-pc/PasswordValidatorNode'
import FormItem from './components/FormItem'
import RegisterCoupon from './components/RegisterCoupon'
import { Switch } from '@ui-pc'
import styles from './index.module.scss'
import fbpng from './facebook.png'
import ggpng from './google.png'
import perkspng from './perks.png'

const LoginModal: React.FC = () => {
  const {
    loginState,
    panelType,
    emailConfig,
    bindEmailConfig,
    passwordConfig,
    fullnameConfig,
    registerState,
    btnLoading,
    resendLoading,
    errorTips,
    couponList,
    couponVisible,
    setCouponVisible,
    handleCancel,
    hanldeUpdateValue,
    handleBlur,
    handleRegister,
    handleSignIn,
    timeDown,
    handleForgotPwd,
    resetModal,
    showResetModal,
    handleSendEmail,
    useChecked,
    checked,
    subText,
    toPanelType,
    showRegPwdError,
    fbLogin,
    ggLogin,
    bindModal,
    bindLoading,
    showBindModal,
    handleBindEmail,
    fbLoading,
    ggLoading,
    isProd
  } = useLogin({ isHernest: true, isMobile: false })

  const renderThirdNode = (isRegister = false) => {
    return (
      <div className={styles['login-list']}>
        <div className={`${styles['login-gg']}`} onClick={ggLogin}>
          <div
            id="google-login-button"
            className={styles['gg-btn-hidden']}></div>
          <Switch either={ggLoading}>
            <div className={styles['third-loading']}>
              <Spin size="small" />
            </div>
          </Switch>
          <img src={ggpng} />
          {isRegister ? 'Create Using Google' : 'Sign in with Google'}
        </div>
        {/* 生产暂时隐藏 */}
        <Switch either={!isProd}>
          <div className={styles['login-fb']} onClick={() => fbLogin(false)}>
            <Switch either={fbLoading}>
              <div className={styles['third-loading']}>
                <Spin size="small" />
              </div>
            </Switch>
            <img src={fbpng} />
            {isRegister ? 'Create Using Facebook' : 'Sign in with Facebook'}
          </div>
        </Switch>
      </div>
    )
  }

  const renderPolicyArticle = (isRegister?: boolean) => {
    return (
      <div
        className={`${styles['terms-policy']} ${isRegister && styles['isRegister']}`}>
        By {isRegister ? 'creating an account' : 'signing in'}, you are agreeing
        to our&nbsp;
        <a
          target="_blank"
          // onClick={handleCancel}
          href={`${routesPath.articleDetail}/Terms-And-Conditions.html?aid=27`}>
          Terms of Use
        </a>
        &nbsp;and&nbsp;
        <a
          target="_blank"
          // onClick={handleCancel}
          href={`${routesPath.articleDetail}/Privacy-Policy.html?aid=20`}>
          Privacy Policy
        </a>
        .
      </div>
    )
  }

  return (
    <>
      {/* 登陆-注册 */}
      <Modal
        open={loginState.loginVisible}
        width={'auto'}
        // open={true}
        title={null}
        onCancel={handleCancel}
        footer={null}
        centered={true}
        closeIcon={<i className="iconfont icon-close"></i>}
        styles={{ mask: { zIndex: 10000 } }}
        wrapClassName={styles['common-login-modal']}>
        {/* 新版登陆+ 引导注册 */}
        <Switch either={panelType === 1}>
          <div
            className={`${styles['login-content']} ${isProd && styles['removeH']}`}>
            <section className={styles['to-login']}>
              <div className={styles['content-title']}>Sign In</div>
              <div className={styles['login-form']}>
                <Form>
                  <FormItem
                    label={'Email*'}
                    item={emailConfig}
                    value={emailConfig.value}
                    onBlur={() => handleBlur('email')}
                    onUpdateValue={(value) => hanldeUpdateValue(value, 'email')}
                  />
                  <FormItem
                    label={'Password*'}
                    customClass={'enter-login-pwd'}
                    item={passwordConfig}
                    value={passwordConfig.value}
                    onBlur={() => handleBlur('password')}
                    onUpdateValue={(value) =>
                      hanldeUpdateValue(value, 'password')
                    }
                  />
                </Form>
                <Button
                  aria-label="@hernest.com"
                  type="primary"
                  size={'large'}
                  loading={btnLoading}
                  onClick={handleSignIn}>
                  Sign In
                </Button>
                <div className={styles['forgot-pwd']} onClick={handleForgotPwd}>
                  Forgot your password?
                </div>
                <div className={styles['login-or']}>or</div>
                {renderThirdNode()}
                {renderPolicyArticle()}
              </div>
            </section>
            <section className={styles['to-register']}>
              <div className={styles['content-title']}>Create an Account</div>
              <p className={styles['perks-tip']}>
                Sign up to get these perks and more:
              </p>
              <img src={perkspng} />
              <Button
                aria-label="@hernest.com"
                type="primary"
                size={'large'}
                onClick={() => toPanelType(2)}>
                Create Account
              </Button>
            </section>
          </div>
        </Switch>
        {/* 新版注册 */}
        <Switch either={panelType === 2}>
          <div
            className={`${styles['register-content']} ${isProd && styles['removeH']}`}>
            <div className={styles['content-title']}>Create an Account</div>
            <div className={styles['login-form']}>
              {renderThirdNode(true)}
              <Form>
                <FormItem
                  label={'Full Name*'}
                  item={fullnameConfig}
                  value={fullnameConfig.value}
                  onBlur={() => handleBlur('fullname')}
                  onUpdateValue={(value) =>
                    hanldeUpdateValue(value, 'fullname')
                  }
                />
                <FormItem
                  label={'Email*'}
                  item={emailConfig}
                  value={emailConfig.value}
                  onBlur={() => handleBlur('email')}
                  onUpdateValue={(value) => hanldeUpdateValue(value, 'email')}
                />
                <FormItem
                  label={'Password*'}
                  item={passwordConfig}
                  value={passwordConfig.value}
                  onBlur={() => handleBlur('password', true)}
                  onUpdateValue={(value) =>
                    hanldeUpdateValue(value, 'password', true)
                  }
                />
              </Form>
              <Switch either={showRegPwdError}>
                <PasswordValidatorNode stateData={registerState} />
              </Switch>

              <div className={styles['subscribe']}>
                <span
                  className={styles['subscribe-check']}
                  onClick={() => useChecked(!checked)}>
                  {checked ? <i className="iconfont icon-gou"></i> : ''}
                </span>
                <p
                  dangerouslySetInnerHTML={{
                    __html: 'Sign up for our newsletters.' // 后端要求前端固定T_T
                  }}></p>
              </div>
              {renderPolicyArticle(true)}
              <Button
                aria-label="@hernest.com"
                type="primary"
                size={'large'}
                className={styles['button']}
                loading={btnLoading}
                onClick={handleRegister}>
                Create Account
              </Button>
              <div className={styles['to-sign-in']}>
                Already have an account?&nbsp;
                <span
                  className={styles['sign-in-btn']}
                  onClick={() => toPanelType(1)}>
                  Sign In
                </span>
              </div>
            </div>
          </div>
        </Switch>
      </Modal>
      {/* 忘记密码-发送邮件 */}
      <Modal
        width={480}
        open={resetModal}
        footer={null}
        centered={true}
        styles={{ mask: { zIndex: 10001 } }}
        onCancel={() => showResetModal(false)}
        closeIcon={<i className="iconfont icon-close"></i>}
        wrapClassName={styles['reset-pwd-modal']}>
        <div className={styles['rb-content']}>
          <div className={styles['content-title']}>Reset My Password</div>
          <div className={styles['rb-tips']}>
            <p>
              We just sent a password reset link to{' '}
              <span className={styles['rb-bold']}>{emailConfig.value}</span>.
            </p>
            <p>
              Still not showing up? You may need to look in your spam folder or
              request a new email below.
            </p>
            <Switch either={!!errorTips}>
              <div className={styles['rb-error-tip']}>{errorTips}</div>
            </Switch>
          </div>
          <Button
            aria-label="@hernest.com"
            type="primary"
            size={'large'}
            className={`${styles['resendBtn']} ${styles['h48']}`}
            loading={resendLoading}
            disabled={!!timeDown}
            onClick={handleSendEmail}>
            Resend Email {timeDown ? `(${timeDown}s)` : ''}
          </Button>
        </div>
      </Modal>
      {/* 第三方登录绑定邮件 */}
      <Modal
        width={480}
        open={bindModal}
        footer={null}
        centered={true}
        styles={{ mask: { zIndex: 10001 } }}
        onCancel={() => showBindModal(false)}
        closeIcon={<i className="iconfont icon-close"></i>}
        wrapClassName={styles['bind-email-modal']}>
        <div className={styles['rb-content']}>
          <div className={styles['content-title']}>
            Complete Account Information
          </div>
          <div className={styles['rb-tips']}>
            <p className={styles['rb-bind-tip']}>
              To ensure the security and convenience of your account, we kindly
              ask you to provide an email address to complete your registration.
            </p>

            <Form>
              <FormItem
                label={'Email*'}
                item={bindEmailConfig}
                value={bindEmailConfig.value}
                onBlur={() => handleBlur('bindEmail')}
                onUpdateValue={(value) => hanldeUpdateValue(value, 'bindEmail')}
              />
            </Form>
          </div>
          <Button
            aria-label="@hernest.com"
            type="primary"
            size={'large'}
            className={
              emailConfig.hasError
                ? `${styles['bindBtnTop']} ${styles['h48']}`
                : `${styles['bindBtn']} ${styles['h48']}`
            }
            loading={bindLoading}
            onClick={handleBindEmail}>
            Create Account
          </Button>
        </div>
      </Modal>
      <RegisterCoupon
        couponList={couponList}
        visible={couponVisible}
        handleClose={() => {
          setCouponVisible(false)
        }}
      />
    </>
  )
}

export default LoginModal
